export enum MediaHavenActionType {
    ADD_OBJECTS = 'ADD_OBJECTS',
    ADD_TO_SELECTION = 'ADD_TO_SELECTION',
    ADD_NEW_ORIGINAL = 'ADD_NEW_ORIGINAL',
    CONTACT_ADMIN = 'CONTACT_ADMIN',
    COUPLE_TO_PARENT = 'COUPLE_TO_PARENT',
    CREATE_RELATION = 'CREATE_RELATION',
    DELETE = 'DELETE',
    DOWNLOAD = 'DOWNLOAD',
    DOWNLOAD_PREVIEW = 'DOWNLOAD_PREVIEW',
    EDIT = 'EDIT',
    EMBED = 'EMBED',
    EMPTY_SELECTION = 'EMPTY_SELECTION',
    OPEN_CONTENT = 'OPEN_CONTENT',
    OPEN_IN_EXTENDED_MEDIA_PLAYER = 'OPEN_IN_EXTENDED_MEDIA_PLAYER',
    PERMANENT_DELETE = 'PERMANENT_DELETE',
    PUBLISH = 'PUBLISH',
    RECOVER_RECORD = 'RECOVER_RECORD',
    DECOUPLE_FROM_PARENT = 'DECOUPLE_FROM_PARENT',
    REMOVE_FROM_SELECTION = 'REMOVE_FROM_SELECTION',
    SET_AS_COLLECTION_COVER = 'SET_AS_COLLECTION_COVER',
    SHARE = 'SHARE',
    SHARE_SELECTION = 'SHARE_SELECTION',
    SHOW_ERRORS = 'SHOW_ERRORS',
    SHOW_PROCESSING_PROGRESS = 'SHOW_PROCESSING_PROGRESS',
    SUBMIT_FOR_EVALUATION = 'SUBMIT_FOR_EVALUATION',
    WATCH = 'WATCH',
    OPEN_IN_VIEWER = 'OPEN_IN_VIEWER',
    CSV_EXPORT = 'CSV_EXPORT',
    SIMILARITY_SEARCH = 'SIMILARITY_SEARCH'
}

// This is the order in which the items appear
export const GENERIC_RECORD_ACTION_TYPES: readonly MediaHavenActionType[] = [
    MediaHavenActionType.ADD_OBJECTS,
    MediaHavenActionType.OPEN_CONTENT,
    MediaHavenActionType.WATCH,
    MediaHavenActionType.EDIT,
    MediaHavenActionType.PUBLISH,
    MediaHavenActionType.SUBMIT_FOR_EVALUATION,
    MediaHavenActionType.ADD_TO_SELECTION,
    MediaHavenActionType.REMOVE_FROM_SELECTION,
    MediaHavenActionType.SET_AS_COLLECTION_COVER,
    MediaHavenActionType.COUPLE_TO_PARENT,
    MediaHavenActionType.DECOUPLE_FROM_PARENT,
    MediaHavenActionType.DOWNLOAD_PREVIEW,
    MediaHavenActionType.DOWNLOAD,
    MediaHavenActionType.SHARE,
    MediaHavenActionType.EMBED,
    MediaHavenActionType.OPEN_IN_VIEWER,
    MediaHavenActionType.CSV_EXPORT,
    MediaHavenActionType.SIMILARITY_SEARCH,
    MediaHavenActionType.DELETE,
    MediaHavenActionType.CONTACT_ADMIN,
    MediaHavenActionType.OPEN_IN_EXTENDED_MEDIA_PLAYER,
    MediaHavenActionType.PERMANENT_DELETE,
    MediaHavenActionType.EMPTY_SELECTION,
    MediaHavenActionType.SHOW_PROCESSING_PROGRESS,
    MediaHavenActionType.SHOW_ERRORS,
    MediaHavenActionType.RECOVER_RECORD
];

export const MH_ICON_ACTIONS: readonly MediaHavenActionType[] = [
    MediaHavenActionType.EDIT,
    MediaHavenActionType.PUBLISH,
    MediaHavenActionType.SUBMIT_FOR_EVALUATION,
    MediaHavenActionType.DOWNLOAD_PREVIEW,
    MediaHavenActionType.DOWNLOAD,
    MediaHavenActionType.SHARE
];
export const MH_ICONLESS_ACTIONS: readonly MediaHavenActionType[] = [
    MediaHavenActionType.ADD_OBJECTS,
    MediaHavenActionType.OPEN_CONTENT,
    MediaHavenActionType.WATCH,
    MediaHavenActionType.ADD_TO_SELECTION,
    MediaHavenActionType.REMOVE_FROM_SELECTION,
    MediaHavenActionType.SET_AS_COLLECTION_COVER,
    MediaHavenActionType.COUPLE_TO_PARENT,
    MediaHavenActionType.DECOUPLE_FROM_PARENT,
    MediaHavenActionType.EMBED,
    MediaHavenActionType.OPEN_IN_VIEWER,
    MediaHavenActionType.CSV_EXPORT,
    MediaHavenActionType.SIMILARITY_SEARCH,
    MediaHavenActionType.DELETE,
    MediaHavenActionType.CONTACT_ADMIN,
    MediaHavenActionType.OPEN_IN_EXTENDED_MEDIA_PLAYER,
    MediaHavenActionType.PERMANENT_DELETE,
    MediaHavenActionType.EMPTY_SELECTION,
    MediaHavenActionType.SHOW_PROCESSING_PROGRESS,
    MediaHavenActionType.SHOW_ERRORS,
    MediaHavenActionType.RECOVER_RECORD
];
